<template>
  <div class="profile">
    <h1>{{ userInfo.firstName }} {{ userInfo.lastName }}</h1>
    <div class="profile-flex">
      <div class="main-profile-sidebar">
        <div class="sidebar">
          <div class="icon-container" @click="toggleEdit">
            <font-awesome-icon class="icon-button" icon="edit"
              >Rediger</font-awesome-icon
            >
          </div>
          <h2>
            <font-awesome-icon class="icon-button colored-icon" icon="user" />
            Personalia
          </h2>
          <PersonaliaComponent v-if="!editMode" />
          <div v-else class="profile-info-container">
            <p>Bosted:</p>
            <input type="text" v-model="tempUserInfo.city" />

            <p>Telefon:</p>
            <input type="tel" v-model="tempUserInfo.telephone" />

            <label class="profile-info-item-edit">
              <span>Kan jobbe fulltid:</span>
              <YesNoChoice
                :initial-state="tempUserInfo.canWorkFullTime"
                v-on:change="(value) => (tempUserInfo.canWorkFullTime = value)"
              />
            </label>

            <label class="profile-info-item-edit">
              <span>Pendlevillighet:</span>
              <YesNoChoice
                :initial-state="tempUserInfo.canCommute"
                v-on:change="(value) => (tempUserInfo.canCommute = value)"
              />
            </label>

            <label class="profile-info-item-edit">
              <span>Flyttevillighet:</span>
              <YesNoChoice
                :initial-state="tempUserInfo.canMove"
                v-on:change="(value) => (tempUserInfo.canMove = value)"
              />
            </label>

            <label class="profile-info-item-edit">
              <span>Førerkort:</span>
              <YesNoChoice
                :initial-state="tempUserInfo.hasDriverLicense"
                v-on:change="(value) => (tempUserInfo.hasDriverLicense = value)"
              />
            </label>

            <label class="profile-info-item-edit">
              <span>Egen bil:</span>
              <YesNoChoice
                :initial-state="tempUserInfo.hasOwnCar"
                v-on:change="(value) => (tempUserInfo.hasOwnCar = value)"
              />
            </label>

            <button @click="saveUserInfo">Lagre</button>
            <button class="button-cancel" @click="toggleEdit">Avbryt</button>
          </div>
        </div>
      </div>

      <div class="main-profile-content">
        <div class="main-content-container">
          <div>
            <div class="icon-container" @click="toggleAboutMe">
              <font-awesome-icon class="icon-button" icon="edit">
                Rediger
              </font-awesome-icon>
            </div>
            <div class="about-me-header">
              <h2 class="title">
                <font-awesome-icon
                  class="icon-button colored-icon"
                  icon="quote-left"
                />
                Litt om meg
              </h2>
            </div>
            <AboutMeComponent v-if="!aboutMeEdit" />
            <section v-else>
              <textarea
                v-model="tempUserBio"
                style="width: 98%; margin: 1%"
                rows="10"
                maxlength="3000"
              >
              </textarea>
              <p
                style="
                  margin: 5px 5px 12.5px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.5);
                "
              >
                Du har brukt {{ this.tempUserBio.length }}/3000 tegn
              </p>
              <div>
                <button class="button-cancel" @click="toggleAboutMe">
                  Avbryt
                </button>
                <button @click="saveUserBio">Lagre</button>
              </div>
            </section>
            <div>
              <h3>Interesser</h3>
              <div class="interest-tags">
                <ProfileInterest />
              </div>
            </div>
          </div>
          <div class="main-portfolio main-portfolio-container">
            <PortfolioComponent />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import YesNoChoice from "@/components/YesNoChoice";

import ProfileInterest from "@/components/ProfileInterest";
import PersonaliaComponent from "@/components/profile_components/PersonaliaComponent.vue";
import AboutMeComponent from "@/components/profile_components/AboutMeComponent.vue";
import PortfolioComponent from "@/components/profile_components/PortfolioComponent.vue";

export default {
  name: "Profile",
  components: {
    YesNoChoice,
    ProfileInterest,
    PersonaliaComponent,
    AboutMeComponent,
    PortfolioComponent,
  },
  data() {
    return {
      auth0Id: this.$auth.user.sub,
      tempUserInfo: {},
      tempUserBio: "",

      editMode: false,
      aboutMeEdit: false,
      togglePortfolio: false,
    };
  },
  async mounted() {
    // Hvis bruker ikke ser på sin egen profil
    // if (this.userInfo.auth0Id == this.$auth.user.sub) {
    //   console.log("User is user");
    //   this.getUserInfo(this.$auth.user.sub);
    // }
    // else {
    //   console.log("User is not user");
    //   this.getUserInfo(this.$route.params.id);
    // }

    this.tempUserBio = this.userInfo.userBio;
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions(["getUserInfo", "setUserInfo", "getUserPortfolio"]),

    async saveUserInfo() {
      let patchData = {
        ...this.tempUserInfo,
        id: this.userInfo.id,
      };

      await this.setUserInfo(patchData)
        .then(() => {
          this.toggleEdit();
        })
        .catch((error) => {
          console.error("Det var et problem med å patche userInfo: ", error);
        });
    },

    async saveUserBio() {
      let patchData = {
        userBio: this.tempUserBio,
        id: this.userInfo.id,
      };

      await this.setUserInfo(patchData)
        .then(() => {
          this.toggleAboutMe();
        })
        .catch((error) => {
          console.error("Det var et problem med å patche userBio: ", error);
        });
    },

    toggleAboutMe: function () {
      this.aboutMeEdit = !this.aboutMeEdit;
      this.tempUserBio = this.userInfo.userBio;
    },

    toggleEdit() {
      this.editMode = !this.editMode;
      this.tempUserInfo = { ...this.userInfo };
    },
  },
};
</script>

<style scoped lang="scss">
input {
  width: 100%;
}

.profile-flex {
  display: flex;
}

.main-profile-sidebar {
  width: 300px;
  margin-right: 2em;
}
.sidebar {
  box-shadow: var(--box-shadow);
  flex-direction: column;
  min-height: 500px;
  padding: 15px 20px;
}

.main-profile-content {
  flex: 1;
  box-sizing: border-box;
}

.main-content-container {
  width: 100%;

  & > * {
    padding: 15px 20px;
    margin-bottom: 2em;
    box-shadow: var(--box-shadow);
    overflow: auto;
  }
}

.main-skills-container {
  box-shadow: var(--box-shadow);
  & > * {
    padding: 0 15px;
  }
}

.code-competencies {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.vertical-flex {
  display: flex;
  flex-direction: column;
}

.horizontal-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.profile-info-item-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #b1b1b1;
  padding: 1em 0.25em;
}

@media only screen and (max-width: 768px) {
  h1 {
    margin: 0.5em;
  }
  .profile-flex {
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: auto;
  }
  .main-profile-sidebar {
    width: 89%;
  }
  .main-content-container {
    padding-top: 2em;
  }
  .projects {
    display: flex;
    justify-content: center;
  }
  .sidebar {
    width: 100%;
  }
}
</style>
